import React from "react";
import { Image, LogoContent } from "../types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

export const Logo = React.memo(({ content }: { content?: LogoContent }) => {
  return (
    <section className="w-full flex flex-col items-center px-[6px] py-[16px] sm:p-[16px] lg:p-[32px] sm:gap-16" aria-label="sky advertising channels">
      <h2 className="sky-h3-bold sm:sky-h3-bold md:sky-h3-bold sky-text-midnightblue text-center">
        {documentToReactComponents(content?.componentTitle as any)}
      </h2>
      <ul className="flex flex-wrap justify-center gap-6 md:gap-8">
        {content?.images?.map((image: Image) => (
          <li key={image.file} className="flex items-center justify-center w-[100px] h-[100px] lg:w-[150px] lg:h-[150px]">
            <button className="focus-visible:outline focus-visible:outline-2 bg-none border-none cursor-default p-0">
              <img src={image?.file} alt={image?.title} className="w-full h-auto" loading="lazy" decoding="async" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
});